module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('b')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('b', [_vm._v("Elsewhere")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“I've gotten to like the castle,” Linda Barclay said as she munched a kosher dill. “But I still have really serious bouts of homesickness.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Sitting with his back against the tree under which he and Linda were enjoying a picnic lunch, Gene Ferraro bit into a cheese-laden cracker. “That's normal. I don't get so much homesick as bored with life here—I mean, in the castle. I'd like to get out into some of the more exciting worlds. Explore a little, you know.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“You're big for adventure. I'm not. I'm basically a homebody.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“And one of the most powerful sorceresses around.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Only in the castle and in some of the magic-is-the-rule worlds. That's what I like about my life here, as opposed to back in the normal world. Magic is fun.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Sure is. Normal world? No such thing. Our world is just one of many—and a pretty dreary one at that.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“It's so nice here.” Linda looked out across the meadow. Bright sunlight brought out the delirious green of the grass, and a soft breeze stirred the budding tree above. It was fine, first-warm-day-of-spring weather.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Yeah, but I'd still like to do some exploring.” Gene looked over his shoulder. “Take that big house over there.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Linda looked at the top of the huge dome that barely showed above the crest of the hill to the right.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Did you ever go over and take a good look at it?\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“No,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“It's a monster. It obviously belongs to someone, as does this whole estate. But the place is deserted.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“I guess that's why everyone in the castle comes here to picnic. It's nice, and there's no one to bother you.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("A bird chirped in a nearby tree. Wooly clouds plodded sheeplike across a blue-violet sky. Gene sighed and stretched out, hands laced together at the back of his head. A sword in its leather scabbard lay in the grass at his left side.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Linda said, “The way I hear, some of the castle's worlds are pretty depopulated, due to wars, plagues, and other nasty things.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Gene looked off into the sky. “'The castle's worlds.’ Say it that way, and it sounds like none of these places would exist if the castle didn't. I wonder.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“I never heard that. Kind of weird to think that our whole Earth existed just because Castle Perilous created a time warp, or whatever you call it.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Spacetime warp. That's a scientific way of putting it. But Castle Perilous and everything about it has to do with magic, not science.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Maybe the magic is just like science, only with different laws.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Gene shrugged. “Hard to say.” He yawned. An insect buzzed about his head. He ignored it.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Linda stretched out one leg and adjusted her tights, then recrossed her legs. She echoed Gene's yawn. “Stop that, it's catching.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Gene feigned a loud, ripping snore.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Linda chuckled. “Maybe I should Z out, too. It was cold in the castle last night. I shivered all night long.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Yeah, it does get cold sometimes,” Gene murmured, eyes closed.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Linda looked off down the slope of the meadow.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Gene?\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Yeah.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Have you ever seen a world with blue-skinned, muscle-bound creatures that wear green armor?\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Gene's right eye popped open. “Eh?\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Look.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("There were three of them, trooping in step up the hill. They were armed with swords and pistols, and all three wore backpacks.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Linda, said, “Something tells me these guys don't live here.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Right, they're definitely prospecting, checking the place out.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Their armor's pretty.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Yeah. Linda, does your magic work here?\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“I've never tried. I whipped the food up back in the castle.” She looked off, her brow furrowed. “I think so.” She made a motion with her hand. “Yeah, it works a little.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Good. Then maybe those guns they're toting won't work.” Gene's right hand went to the hilt of his sword. “Here they come, straight for us. Get ready to move fast.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("At the last minute, the three strange creatures changed course to the left and marched by, their big webbed feet crushing the overgrown grass in purposeful steps. One of them regarded Gene and Linda coldly. The others looked straight ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("When they disappeared over the rise, Gene let go of his sword. “I wonder what that was all about.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Linda shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Gene snapped his fingers. “Wait a minute. I thought something was familiar about them! Don Kelly was telling me about how people have been seeing strange-looking new aliens around the castle. Blue-skinned, short, chunky guys, lots of them, usually going around in threes. They don't mix, keep to themselves. In fact, they're supposed to be kind of belligerent, if pressed. Those must be the ones.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“I wonder what their world is like.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Gene shook his head. “Each one of those guys must go two seventy-five, maybe three hundred pounds. At least. They look like good fighters. Too good.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Do you think they're trouble?\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Gene shrugged. “No real reason to think they would be. They seem to mind their own business.” He mulled it over. “Trouble is, they look like they have business.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Linda nodded. “Serious business.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("They were silent for a while.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Have we been here a year, yet?” Linda asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Who's keeping trade of time? Yeah, I guess.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Linda let out a long breath. “It seems shorter. Sometimes I still think this is all a dream.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“I know what you mean.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“A year ago I'm in Los Angeles, leading a normal life. I have a dull job, but I live near the beach in Santa Monica. It's okay, I guess. But I get depressed sometimes. A lot of the time. And I take a lot of pills. Then one day, when I'm feeling especially down, I open my closet and find that someone's torn out the back wall. I walk through and find this place that looks like the inside of a castle.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Gene broke in, “And the opening closes behind you, and you can't find a way back to your closet. And then you find there are all kinds of people in this castle, some good, some bad, some strange, some not. And the place is absolutely crazy, with doorways that lead to a million different worlds and universes—\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Crazy isn't the word. Insane. Bonkers. Stark raving Looney-Toons.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Never a dull moment. And there's even a king in this castle, by the name of Incarnadine.” Gene sighed. “Yeah. Sounds familiar, except I came in by way of an odd doorway in a parking garage in downtown Pittsburgh, Pennsylvania. Of all places.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Want to go back?\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Huh? To our world? The good old USA, where I was born, like the song says?\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Well, I meant the castle. But answer the question any way you want to.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“I dunno. The only thing that worries me is my parents. They must have given up hope by now.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“And mine.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Sure wish there was a way to get a message back.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Just a message?\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Gene nodded. “I like Castle Perilous. It's the ultimate trip, to use an expression out of the sixties.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Let's trip back to the castle. I want to take a nap.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“At once, milady.” Gene got to his feet and strapped on his sword.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Linda packed the wicker basket while Gene folded up the square of white linen they had used for a ground cloth. Then they both headed up the hill. The portal leading back to the castle stood among some trees just over the rise.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“I'm glad Snowclaw finally found a way back to his world,” Gene said.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Poor baby. He was practically dying from the heat.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“Yeah. He was in pretty bad shape. His fur was coming off in hunks.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“I miss him.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("“So do I.\"")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('b')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e2bae02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section15.vue
// module id = 105
// module chunks = 0